const LoadingSpinner = () => (
  <div className="flex justify-center items-center py-8">
    <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-pinkAccent"></div>
  </div>
);

export default LoadingSpinner;